/// <amd-module name="DistributedTaskUI/Logs/VerticalTab/DefaultVerticalItemRenderer" />
import * as React from "react";

import { IStatusProps, Status, StatusSize } from "VSSUI/Status";
import { Tooltip } from "VSSUI/TooltipEx";
import { IVssIconProps, VssIcon } from "VSSUI/VssIcon";

import { css } from "VSSUI/Util";

import "VSS/LoaderPlugins/Css!DistributedTaskUI/Logs/VerticalTab/DefaultVerticalItemRenderer";

export interface IDefaultVerticalItemRendererProps {
    title: string;
    iconProps?: IVssIconProps;
    footerText?: string | JSX.Element;
    footerTooltipContent?: string;
    statusIconProps?: IStatusProps;
    ariaLabel?: string;
    ariaHidden?: boolean;
}

export class DefaultVerticalItemRenderer extends React.Component<IDefaultVerticalItemRendererProps, {}> {

    public render(): JSX.Element {
        const iconProps = this.props.iconProps;
        const footerTooltipContent = (this.props.footerTooltipContent || this.props.footerText) as string;

        const statusIconProps = this.props.statusIconProps;
        return (
            <div className={"vertical-tab-item-content flex flex-center"} aria-label={this.props.ariaLabel} aria-hidden={this.props.ariaHidden}>
                {
                    iconProps &&
                    <VssIcon
                        className={css(iconProps.className, "vertical-tab-item-icon", "log-task-state")}
                        iconName={iconProps.iconName}
                        iconType={iconProps.iconType}
                        style={iconProps.style}
                    />
                }
                {
                    statusIconProps &&
                    <Status
                        size={StatusSize.m}
                        {...statusIconProps}
                        className={css("vertical-tab-item-icon", "log-task-state", "flex-noshrink")}
                    />
                }
                <div className="vertical-tab-item-description">

                    <Tooltip overflowOnly={true} text={this.props.title}>
                        <div className="vertical-tab-item-text ellipsis-overflow">
                            {this.props.title}
                        </div>
                    </Tooltip>
                    {
                        this.props.footerText &&
                        <Tooltip overflowOnly={true} text={footerTooltipContent}>
                            <div className={"vertical-tab-item-footer-text ellipsis-overflow"}>
                                {this.props.footerText}
                            </div>
                        </Tooltip>
                    }
                </div>
            </div>
        );
    }
}
